export default __webpack_public_path__ + "static/media/recorte_22.fc8c09e0.JPG";